/* eslint-disable react/no-children-prop */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import * as React from "react"
import { createRoot } from "react-dom/client"
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom"

import NotAvailable from "./components/NotAvailable"
import {
  fetchAboutPageData,
  fetchGlobalData,
  fetchHomePageData,
  fetchFaqPageData,
  fetchInfoPageData,
  fetchNewsArticlePageData,
  fetchNewsPageData,
  fetchRegistrationPageData,
  fetchTestimonialsPageData
} from "./helpers/getData"
import { RootLayout } from "./pages/RootLayout"
import * as serviceWorker from "./serviceWorker"

// Temporary: set to false to restore the site
const SHOW_NOT_AVAILABLE = true

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/pt-br" />
  },
  {
    id: "root",
    path: ":lang",
    loader: async ({ params }) => fetchGlobalData(params.lang),
    element: <RootLayout />,
    children: [
      {
        index: true,
        path: "",
        lazy: () => import("./pages/Home"),
        loader: async ({ params }) => fetchHomePageData(params.lang)
      },
      {
        path: "about",
        lazy: () => import("./pages/About"),
        loader: async ({ params }) => fetchAboutPageData(params.lang)
      },
      {
        path: "faq",
        lazy: () => import("./pages/FAQ"),
        loader: async ({ params }) => fetchFaqPageData(params.lang)
      },
      {
        path: "testimonials",
        lazy: () => import("./pages/Testimonials"),
        loader: async ({ params }) => fetchTestimonialsPageData(params.lang)
      },
      {
        path: "register",
        lazy: () => import("./pages/Registration"),
        loader: async () => fetchRegistrationPageData()
      },
      {
        path: "news",
        lazy: () => import("./pages/News"),
        loader: async ({ params, request }) => fetchNewsPageData(new URL(request.url).searchParams, params.lang)
      },
      {
        path: "news/:slug",
        lazy: () => import("./pages/NewsArticle"),
        loader: async ({ params }) => fetchNewsArticlePageData(params.slug, params.lang)
      },
      {
        path: ":slug",
        lazy: () => import("./pages/Info"),
        loader: async ({ params }) => fetchInfoPageData(params.lang, params.slug)
      },
      {
        path: "*",
        lazy: () => import("./pages/NotFound")
      }
    ]
  }
])

const App = () => {
  if (SHOW_NOT_AVAILABLE) {
    return <NotAvailable />
  }

  return (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  )
}

createRoot(document.getElementById("root")).render(<App />)

serviceWorker.unregister()
